import styles from "./Actions.module.css";
import Button from "../../../../UI/Button";
import { useContext, useEffect, useState } from "react";
import CartContext from "../../../../store/cart-context";
import NavigationContext from "../../../../store/navigation-context";

export default function Actions({ item }) {
  const cartCtx = useContext(CartContext);
  const navCtx = useContext(NavigationContext);

  const [reservePop, setReservePop] = useState(false);

  const onReserveHandler = () => {
    cartCtx.addItem([item]);
    setReservePop(true);
    setTimeout(() => {
      setReservePop(false);
    }, [200]);
  };

  return (
    <main className={styles.main}>
      <div className={styles.text}>Rezerviraj svoj proizvod odmah!</div>
      <div className={styles.actions}>
        <div>
          <Button
            onClick={() => {
              navCtx.setIsContacting(true);
            }}
          >
            Kontakt
          </Button>
        </div>

        <div className={styles[reservePop && `reserve-pop`]}>
          <Button
            disabled={
              (cartCtx?.items?.length > 0 &&
                cartCtx.items.find((e) => (e.id = item.id))?.quantity >=
                  item.stock_quantity &&
                true) ||
              false
            }
            onClick={onReserveHandler}
          >
            Rezerviraj
          </Button>
        </div>
      </div>
    </main>
  );
}
